<div class="tray__container">
  <header class="tray__header">
    <h4 class="tray-header__heading">
      <i class="ico-ai sz-m"></i>
      {{ vehicle?.plateNumber }}
    </h4>
    <a class="tray-header__button" href="javascript:void(0)"
       (click)="closeAiEvents()">
      <i class="ico-close"></i>
    </a>
  </header>
  <div class="tray__filter form--soft">
<!--    <div class="switch">-->
<!--      <a class="switch__item">-->
<!--        <i class="ico-alarm"></i>-->
<!--      </a>-->
<!--      <a class="switch__item switch__item&#45;&#45;active">-->
<!--        <i class="ico-comment"></i>-->
<!--      </a>-->
<!--      <a class="switch__item switch__item&#45;&#45;active">-->
<!--        <i class="ico-doc"></i>-->
<!--      </a>-->
<!--    </div>-->
<!--    <app-date-time-picker>-->
<!--    </app-date-time-picker>-->
<!--    <div class="input-group">-->
<!--      <input type="text" class="form-control">-->
<!--      <button class="events-header__button">-->
<!--        <i class="ico-search"></i>-->
<!--      </button>-->
<!--    </div>-->

    <div class="events__notification ml-auto" *ngIf="newMessageFlag" (click)="scrollToBottom()">
      <div class="notification__icon info">
        <i class="ico-comment"></i>
        <div class="notification__indicator"><span>!</span><div class="pulsate"></div></div>
      </div>
      {{'ai-events.aiEventEntry.newEventNotification' | translate}}
      <i class="ico-arrow-down"></i>
    </div>
  </div>

  <div class="tray__list events__list" id="events__list"
       infinite-scroll
       [infiniteScrollUpDistance]="scrollUpDistance"
       [infiniteScrollDistance]="scrollDownDistance"
       [infiniteScrollThrottle]="throttle"
       [infiniteScrollDisabled]="scrollDisabled"
       [scrollWindow]="false"
       (scrolledUp)="addAiEvents(true)"
       (scrolled)="addAiEvents(false)">
    <div class="event">
      <ng-container *ngFor="let event of events">
        <article class="event--trigger event--{{event.triggerAction}}">
          <div class="event__icon">
          </div>
          <div class="event__details">
            <div class="event__type">
              {{'ai-events.aiEventEntry.triggerAction.' + event.triggerAction | translate}}
            </div>
            <div class="event__text">
              <span *ngIf="event.triggerEvent != null">{{event.triggerEvent}}</span>
            </div>
          </div>
          <div class="event__timestamp">
            {{ getTime(event) }}
          </div>
          <div class="event__actions">
            <a *ngIf="event.messageSentOn"
               class="icon-action"
               [ngbTooltip]="'ai-events.tooltip.findMessage' | translate"
               (click)="findAndScrollTo(event)">
              <i class="ico-comment"></i>
            </a>
            <a *ngIf="event.triggerAction === 'FORM'"
               class="icon-action"
               [ngbTooltip]="'ai-events.tooltip.reviewForm' | translate"
               (click)="reviewForm(event)">
              <i class="ico-doc-check"></i>
            </a>
          </div>
        </article>
        <div class="automation__group" *ngIf="event.events.length > 0">
          <ng-container *ngFor="let data of event.events">
            <article class="event--automation" [class]="getEventClass(data)">
              <div class="event__icon"></div>
              <div class="event__details">
                <div class="event__type">{{getEventTypeTranslation(data)}}</div>
                <div *ngIf="data.detailedActionType === 'MESSAGE_TRANSLATION'" class="event__text">
                  {{('ai-events.aiEventEntry.detailedActionTypes.' + data.detailedActionType | translate:{message: data.message.message, translation: data.message.translation})}}
                </div>
                <div *ngIf="data.detailedActionType === 'VOICE_TRANSCRIPTION'" class="event__text">
                  {{('ai-events.aiEventEntry.detailedActionTypes.' + data.detailedActionType | translate:{message: data.postAiResult || ''})}}
                </div>
                <div *ngIf="data.actionType === 'TASK'" class="event__text">
                  {{'ai-events.aiEventEntry.detailedActionTypes.' + data.detailedActionType | translate}}
                </div>
                <div *ngIf="data.detailedActionType === 'MESSAGE_SENT'" class="event__text">
                  {{('ai-events.aiEventEntry.detailedActionTypes.' + data.detailedActionType | translate:{message: data.preAiResult || ''})}}
                </div>
                <div *ngIf="data.detailedActionType === 'CMR_VALIDATION'" class="event__text">
                  {{data.postAiResult}}
                </div>
              </div>
              <div class="event__timestamp">
                {{data.createdAt | date:'yyyy-MM-dd HH:mm'}}
              </div>
              <div class="event__actions">
                <a *ngIf="data.detailedActionType === 'MESSAGE_TRANSLATION'" class="icon-action" tabindex="2">
                  <i class="ico-comment"></i>
                </a>
                <a *ngIf="data.actionType === 'TASK'" class="icon-action"
                   tabindex="2"
                   [ngbTooltip]="'ai-events.tooltip.openTasks' | translate"
                   (click)="openTasks()">
                  <i class="ico-check"></i>
                  <span>{{vehicle.taskCount}}</span>
                </a>
                <ng-container *ngIf="(data.actionType === 'TASK' || data.actionType === 'FORM') && data.revertedAt == null">
                        <span appUndoReason
                              [inputTitle]="'ai-events.undoReason'"
                              [inputType]="'string'"
                              [ngbTooltip]="'ai-events.tooltip.restoreStatus' | translate"
                              (reason)="revert(data, $event)"
                              role="button"
                              class="icon-action icon-action--revert">
                          <i class="ico-undo"></i>
                        </span>
                </ng-container>
              </div>
            </article>
          </ng-container>
        </div>
      </ng-container>
    </div>
  </div>
  <div class="tray__input form--soft">
    <div class="uploaded-file" id="upload-e-file">
      <i class="ico-paperclip" *ngIf="file"></i>
      <input type="text" value="{{file.name}}" *ngIf="file" appAutocompleteOff>
      <i class="ico-close delete-file" (click)="removeFile()" *ngIf="file"></i>
    </div>
    <div class="input-group chat-text">
      <textarea type="text"
                class="form-control"
                rows="1"
                id="text-e-input"
                placeholder="{{'chat.messages.text' | translate}}"
                maxlength="10000"
                (paste)="onPaste($event)"
                (keydown.shift.enter)="onKeyShiftEnter($event)"
                (keydown.enter)="onKeyEnter($event)"
                [(ngModel)]="chatText">
      </textarea>
      <div class="input__buttons" id="text-e-buttons">
        <a class="input__button send" (click)="addChatItem()">
          <i class="ico-send"></i>
        </a>
        <div class="input__button ico-upload upload">
          <input id="upload"
                 class="file-upload-input"
                 type="file"
                 accept=".pdf,.txt,image/*,.xlsx,.xls,video/*"
                 (change)="fileChange(upload)"
                 #upload>
        </div>
      </div>
    </div>
  </div>
</div>
